import { AutogenLayoutRenditionProfiles } from "./autogen/AutogenLayoutRenditionProfiles";
import { ClickEvent, DataSourceExecutionEvent, DropdownSelectionEvent, SelectionMode, TableRowDisplayEvent,  TableSelectionEvent } from "@mcleod/components";
import { DropdownItem, Textbox, DataSource, DataSourceMode } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";
import { ImgLic } from "./ImgLic";

const funcsMap = new Map<string, string>();
let renlgxLicensed = false;

export class RenditionProfiles extends AutogenLayoutRenditionProfiles {

    private reviewRows: ModelRow[] = [];
    private selectedPrinter = null;
    private timer: any;
    private opCnt = -1;

    override async onLoad() {
        //console.log(this);
        this.sourceDpsqlh.search();     //get all fields
        this.sourceDxmasterp.search();
        this.sourceRenditionDocumentProfiles.orderBy = [{field: "docp_seq", sort: "asc"}];
        renlgxLicensed = await ImgLic.renlgxLicensed();
        //hide portal columns if not licensed
        this.buttonOpenPortals.visible = renlgxLicensed;
        this.tblLogixProfiles.setColumnVisibility(this.tblLogixProfiles._columns[1],renlgxLicensed);    //url
        this.tblLogixProfiles.setColumnVisibility(this.tblLogixProfiles._columns[2],renlgxLicensed);    //login
        this.tblLogixProfiles.setColumnVisibility(this.tblLogixProfiles._columns[3],renlgxLicensed);    //pwd
        this.tblLogixProfiles.setColumnVisibility(this.tblLogixProfiles._columns[4],renlgxLicensed);    //file name
        this.tblLogixProfiles.setColumnVisibility(this.tblLogixProfiles._columns[5],renlgxLicensed);    //format
        this.tblLogixProfiles.setColumnVisibility(this.tblLogixProfiles._columns[8],renlgxLicensed);    //color
        this.tblLogixProfiles.setColumnVisibility(this.tblLogixProfiles._columns[9],renlgxLicensed);    //combine type
        this.tblLogixProfiles.setColumnVisibility(this.tblLogixProfiles._columns[10],renlgxLicensed);   //separates invoices
        this.sourceRenditionLogixProfiles.search();
    }

 /** This is an event handler for the AfterTabSelection event of tabset1. */
  async tabset1AfterTabSelection(event: ClickEvent) {
      this.titleSingular = this.tabset1.getActiveTab().caption;
      if( this.tabset1.getActiveTab().caption == this.tabTab7.caption )
      {
          clearInterval(this.timer);
          this.timer = setInterval(() => this.UpdateOverrideDropDownItems(), 2000);
      }
      else if( this.tabset1.getActiveTab().caption == this.tabTab9.caption )
      {
          await this.sourceRenditionProperties.search( { "renp_xid": ">0" } );
          await this.sourceRenditionLogixProfiles.search();
          clearInterval(this.timer);
          this.timer = null;
      }
      else
      {
          clearInterval(this.timer);
          this.timer = null;
      }
  }

/** This is an event handler for the afterExecution event of sourceRenditionDocumentProfiles. */
  sourceRenditionDocumentProfilesAfterExecution(event: DataSourceExecutionEvent) {
    if( this.tbDocProf2.items )
        return;
    let idx=0;
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    let docpid = null;
    for (const row of rows) {
        //console.log("Row: ", row );
        if( docpid != row._data.docp_id )
        {
            docpid = row._data.docp_id;
            //items.push({ caption: row._data.docp_id, value: row._data.docp_id });
            items.push(new DropdownItem(row._data.docp_id, row._data.docp_id));
            if( this.tbDocProf3.text == row._data.docp_id )
                idx = items.length - 1;     //newly added profile
        }
    }
    this.tbDocProf2.items = items;
    //select 1st profile
    if( items.length > 0 )
    {
        this.pbDelDocProf.enabled = true;
        this.tbDocProf2.text = this.tbDocProf2.items[idx].displayValue;
        if( this.tbDocProf3.text == "" )
        {   //1st time loading profiles, select first item
            this.tbDocProf2.selectedItem = this.tbDocProf2.items[idx];
        }
    }
  }

/** This is an event handler for the afterExecution event of sourceRenditionOverrideProfiles. */
  sourceRenditionOverrideProfilesAfterExecution(event: DataSourceExecutionEvent) {
    if( this.tbOverrideProfiles.items )
        return;
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    let oid = null;
    for (const row of rows) {
        //console.log("Row: ", row );
        if( oid != row._data.ovrh_id )
        {
            oid = row._data.ovrh_id;
            //items.push({ caption: row._data.ovrh_desc, value: row._data.ovrh_id });
            items.push(new DropdownItem(row._data.ovrh_id, row._data.ovrh_desc));
        }
    }
    this.tbOverrideProfiles.items = items;
    //select 1st profile
    if( items.length > 0 )
    {
        this.tbOverrideProfiles.text = this.tbOverrideProfiles.items[0].displayValue;
        this.sourceRenditionOverrideProfiles.search( { "ovrd_id": this.tbOverrideProfiles.items[0].value } );
    }
}

/** This is an event handler for the onDropdownSelection event of tbOverrideProfiles. */
  tbOverrideProfilesAfterDropdownSelection(event: DropdownSelectionEvent) {
    this.sourceRenditionOverrideProfiles.orderBy = [{field: "ovrd_seq", sort: "asc"}];
    this.sourceRenditionOverrideProfiles.search( { "ovrh_id": event.selection.value } );
  }

/** This is an event handler for the beforeExecution event of sourceRenditionOverrideProfiles. */
  sourceRenditionOverrideProfilesBeforeExecution(event: DataSourceExecutionEvent) {
    const mode: any = event.getAction();
  }

/** This is an event handler for the onDataDisplay event of table7. */
  async table7OnRowDisplay(event: TableRowDisplayEvent) {
    // const txtboxA = event.getTableRow().findComponentById("textboxOvrhDesc") as Textbox;
    // const txtboxC = event.getTableRow().findComponentById("textboxC") as Textbox;
    const row: any = event.getTableRow().data;
    let found=0;
    const items: DropdownItem[] = [];
    for( let i = 0; i < this.tbOverrideProfiles.items.length; i++ )
    {
        items[i] = this.tbOverrideProfiles.items[i];
        const item: any = this.tbOverrideProfiles.items[i];
        if( item.caption == row._data.ovrh_desc )
        {
            found = 1;
            //break;
        }
    }
    if( found == 0 )
    {   //see if we need to update ovrh_desc
        for( let i = 0; i < this.tbOverrideProfiles.items.length; i++ )
        {
            const item: any = this.tbOverrideProfiles.items[i];
            if( item.value == row._data.ovrh_id )
            {
                found = 1;  //update description
                this.tbOverrideProfiles.items[i].caption = row._data.ovrh_desc;
                this.tbOverrideProfiles.text = row._data.ovrh_desc;
                break;
            }
        }
    }
    if( found == 0 )
    {   //add new override profile
        //items.push({ caption: row._data.ovrh_desc, value: row._data.ovrh_id });
        items.push(new DropdownItem(row._data.ovrh_id, row._data.ovrh_desc));
        this.tbOverrideProfiles.items = items;
        //select last added profile
        const iidx = this.tbOverrideProfiles.items.length-1;
        this.tbOverrideProfiles.text = this.tbOverrideProfiles.items[iidx].displayValue;
        this.sourceRenditionOverrideProfiles.orderBy = [{field: "ovrd_seq", sort: "asc"}];
        await this.sourceRenditionOverrideProfiles.search( { "ovrd_id": this.tbOverrideProfiles.items[iidx].value } );
    }
  }

  async UpdateOverrideDropDownItems()
  { //used to update drop down items after a delete
    clearInterval(this.timer);
    this.timer = null;
    if( this.tbOverrideProfiles.items == null )
        return;
    if( this.opCnt != this.tbOverrideProfiles.items.length || this.table7.rowCount == 0 )
    {
      this.sourceRendOverrideProfiles.orderBy = [{field: "ovrh_id", sort: "asc"}];
      await this.sourceRendOverrideProfiles.search( { "ovrh_id": ">0" } );
      const rows: any[] = this.sourceRendOverrideProfiles.data;
      const items: DropdownItem[] = [];
      let oid = null;
      for (const row of rows) {
          //console.log("Row: ", row );
          if( oid != row._data.ovrh_id )
          {
              oid = row._data.ovrh_id;
              //items.push({ caption: row._data.ovrh_desc, value: row._data.ovrh_id });
              items.push(new DropdownItem(row._data.ovrh_id, row._data.ovrh_desc));
            }
      }
      this.tbOverrideProfiles.items = items;
      this.opCnt = this.tbOverrideProfiles.items.length;
    }
  }

/** This is an event handler for the onContentsChanged event of table7. */
  // async table7OnContentsChanged(event: TableContentsChangedEvent) {
  //   //called only on add, not on delete
  //   const action: any = event.getAction();
  //   if( action == "delete" && this.table7.rowCount == 0 )
  //   {
  //     this.tbOverrideProfiles.items = null;
  //     this.sourceRenditionOverrideProfiles.orderBy = [{field: "ovrd_seq", sort: "asc"}];
  //     await this.sourceRenditionOverrideProfiles.search( { "ovrd_id": ">0" } );
  //   }
  // }

/** This is an event handler for the onTableRowMove event of table7. */
  // async table7TableRowMove(event: TableRowMoveEvent) {
  //   //not called on delete either
  //   const action: any = event.getTableRow().mode;
  //   if( action == "delete" && this.table7.rowCount == 0 )
  //   {
  //     this.tbOverrideProfiles.items = null;
  //     this.sourceRenditionOverrideProfiles.orderBy = [{field: "ovrd_seq", sort: "asc"}];
  //     await this.sourceRenditionOverrideProfiles.search( { "ovrd_id": ">0" } );
  //   }
  // }

/** This is an event handler for the onRemoteDataChange event of sourceRenditionOverrideProfiles. */
  // async sourceRenditionOverrideProfilesOnRemoteDataChange(event: DataSourceRemoteDataChangeEvent) {
  //   let eventChangeType = event.change.type;
  //   if( eventChangeType == ModelDataChangeType.DELETE )
  //       eventChangeType = ModelDataChangeType.DELETE;
  //   const changedRow = event.change.data as ModelRow;
  //   const oid = changedRow.get("ovrd_id");
  //   const action: any = this.sourceRenditionOverrideProfiles.mode;
  //   if( eventChangeType == ModelDataChangeType.DELETE )
  //   {
  //       if( action == "delete" && this.table7.rowCount == 0 )
  //       {
  //           this.tbOverrideProfiles.items = null;
  //           this.sourceRenditionOverrideProfiles.orderBy = [{field: "ovrd_seq", sort: "asc"}];
  //           await this.sourceRenditionOverrideProfiles.search( { "ovrd_id": ">0" } );
  //       }
  //   }
  // }


/** This is an event handler for the onSelect event of tblApps. */
  tblAppsOnSelect(event: TableSelectionEvent) {
    if( this.tblApps.selectedRow != null )
        this.sourceImapCats.search( { icat_appid: this.tblApps.selectedRow.data._data.imap_appid } );
  }

/** This is an event handler for the afterDropdownSelection event of tbDocProf2. */
  async tbDocProf2AfterDropdownSelection(event: DropdownSelectionEvent) {
    if( event.selection == null )
        return;
    this.tblDocProf.dataSource = null;
    this.sourceRenditionDocumentProfiles.orderBy = [{field: "docp_seq", sort: "asc"}];
    await this.sourceRenditionDocumentProfiles.search( { "docp_id": event.selection.displayValue, doc_seq: 1 } );
    const row: any = this.sourceRenditionDocumentProfiles.data[0];
    const app1: any = row._data.docp_appid;
    for( let i = 0; i < this.tblApps.rowCount; i++ )
    {
        const rowApp: any = this.tblApps.rows[i].data;
        if( rowApp._data.imap_appid == app1 )
        {
            this.tblApps.selectedRow = this.tblApps.rows[i];
            this.tblApps.selectionMode = SelectionMode.NONE;
            break;
        }
    }
    this.tblDocProf.dataSource = this.sourceRenditionDocumentProfiles;
    await this.sourceRenditionDocumentProfiles.search( { "docp_id": event.selection.displayValue } );
  }


/** This is an event handler for the onRowDisplay event of tblDocProf. */
  tblDocProfOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox1 = event.getTableRow().findComponentById("textbox1") as Textbox;
    const txtbox2 = event.getTableRow().findComponentById("textbox2") as Textbox;
    const row1: any = event.getTableRow().data;
    const app1: any = row1._data.docp_appid;
    const catid1: any = row1._data.docp_catid;
    let rows: any = this.sourceImapCats.data;
    for( const row of rows )
    {
        const app2: any = row._data.icat_appid;
        const catid2: any = row._data.icat_catid;
        if( app1 == app2 && catid1 == catid2 )
        {
            let catdesc: string = row._data.icat_catdesc.toString();
            catdesc = catdesc.replace("&","");
            //const catd = catid1 + " " + catdesc;
            //row1.set( "catdesc", catdesc );
            if( txtbox2 )
                txtbox2.setProps({ text: catdesc/*, color: "success"*/ });
            break;
        }
    }

    rows = this.sourceImgApps.data;
    for( const row of rows )
    {
        const app2: any = row._data.imap_appid;
        if( app1 == app2 )
        {
            let appname: string = row._data.imap_appname.toString();
            appname = appname.replace("&","");
            const appn = app1 + " - " + appname;
            //row1.set( "appname", appn );
            if( txtbox1 )
                txtbox1.setProps({ text: appn/*, color: "warning"*/ });
            break;
        }
    }

  }

/** This is an event handler for the onRowDisplay event of tblApps. */
  tblAppsOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox3 = event.getTableRow().findComponentById("textbox3") as Textbox;
    const row1: any = event.getTableRow().data;
    const appid: any = row1._data.imap_appid;
    let appname: string = row1._data.imap_appname.toString();
    appname = appname.replace("&","");
    const appn = appid + " - " + appname;
    if( txtbox3 )
        txtbox3.setProps({ text: appn/*, color: "warning"*/ });
  }

/** This is an event handler for the onRowDisplay event of tblDocs. */
  tblDocsOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox4 = event.getTableRow().findComponentById("textbox4") as Textbox;
    const row1: any = event.getTableRow().data;
    const catid: any = row1._data.icat_catid;
    let catdesc: string = row1._data.icat_catdesc.toString();
    catdesc = catdesc.replace("&","");
    const catn = catid + " - " + catdesc;
    if( txtbox4 )
        txtbox4.setProps({ text: catn/*, color: "warning"*/ });
  }

/** This is an event handler for the onClick event of pbAddDocProf. */
  pbAddDocProfOnClick(event: ClickEvent) {
    if( this.pbAddDocProf.caption == "Add" )
    {
        this.tbDocProf2.visible = false;
        this.tbDocProf3.text = "";
        this.tbDocProf3.visible = true;
        this.tbDocProf3.focus();
        this.tblApps.selectionMode = SelectionMode.SINGLE;
        this.pbDelDocProf.enabled = false;
        this.sourceRenditionDocumentProfiles.search( { "docp_id": "-1-" } );
        this.pbAddDocProf.caption = "Abort";
    }
    else
    {
        this.tbDocProf3.text = "";
        this.tbDocProf3.visible = false;
        this.tbDocProf2.visible = true;
        this.pbDelDocProf.enabled = true;
        this.pbAddDocProf.caption = "Add";
        if( this.tbDocProf2.text != "" )
            this.sourceRenditionDocumentProfiles.search( { "docp_id": this.tbDocProf2.text } );
    }
  }

/** This is an event handler for the onClick event of pbDelDocProf. */
  async pbDelDocProfOnClick(event: ClickEvent) {
    if( this.tbDocProf2.text != "" )
    {
        const row: any = new ModelRow("imaging/Rendition-DocumentProfiles", true);
        const id = this.tbDocProf2.text;
        await this.sourceRenditionProperties.search( { "renp_docid": id } );
        if( this.sourceRenditionProperties.rowCount > 0 )
        {
            //alert("Cannot delete document profile '" + id + "' because it has associated rendition properties.");
            CommonDialogs.showMessage("Cannot delete document profile '" + id + "' because it has associated rendition properties.",
                "Document Power", { resizable: true, movable: true });
            return;
        }
        await this.sourceRenditionProperties.search( { "renp_printdocid": id } );
        if( this.sourceRenditionProperties.rowCount > 0 )
        {
            CommonDialogs.showMessage("Cannot delete document profile '" + id + "' because it has associated rendition properties.",
                "Document Power", { resizable: true, movable: true });
            return;
        }
        await this.sourceRenditionProperties.search( { "renp_emaildocid": id } );
        if( this.sourceRenditionProperties.rowCount > 0 )
        {
            CommonDialogs.showMessage("Cannot delete document profile '" + id + "' because it has associated rendition properties.",
                "Document Power", { resizable: true, movable: true });
            return;
        }
        await this.sourceRenditionProperties.search( { "renp_faxdocid": id } );
        if( this.sourceRenditionProperties.rowCount > 0 )
        {
            CommonDialogs.showMessage("Cannot delete document profile '" + id + "' because it has associated rendition properties.",
                "Document Power", { resizable: true, movable: true });
            return;
        }
        await this.sourceRenditionProperties.search( { "renp_ftpdocid": id } );
        if( this.sourceRenditionProperties.rowCount > 0 )
        {
            CommonDialogs.showMessage("Cannot delete document profile '" + id + "' because it has associated rendition properties.",
                "Document Power", { resizable: true, movable: true });
            return;
        }
        const response = await CommonDialogs.showYesNo("Warning: Delete this document profile [" + id + "]?", "Document Power");
        if( response )
        {
            //await this.sourceRenditionDocumentProfiles.search( { "docp_id": id } );
            //if( this.sourceRenditionDocumentProfiles.rowCount > 0 )
            {
                const rcnt = this.sourceRenditionDocumentProfiles.rowCount;
                this.sourceRenditionDocumentProfiles.mode = DataSourceMode.NONE;
                const tblDocProfRows = this.tblDocProf.rows;
                const rowDel: any = new ModelRow("imaging/Rendition-DocumentProfiles", true);
                for( const rowD of tblDocProfRows )
                {
                    const recid: any = rowD.data._data.docp_recid;
                    rowDel.set( "docp_recid", recid );
                    rowDel.mode = DataSourceMode.NONE;
                    this.sourceRenditionDocumentProfiles.setRowsAndMode( rowDel.mode, [rowDel], null );
                    this.sourceRenditionDocumentProfiles.delete();
                }
                //delete item from dropdown
                const items: any = this.tbDocProf2.items;
                for( let i=0; i < items.length; i++ )
                {
                    const item: any = items[i];
                    if( item.displayValue == id )
                    {
                        items.splice(i, 1);
                        break;
                    }
                }
                this.tbDocProf2.items = items;
                this.tbDocProf2.text = "";
            }
        }
    }
  }

/** This is an event handler for the onClick event of pbAddSeq. */
  async pbAddSeqOnClick(event: ClickEvent) {
    if( this.tblDocs.selectedRow != null && this.tblApps.selectedRow != null &&
        (( this.tbDocProf2.visible && this.tbDocProf2.text != "" ) ||
        ( this.tbDocProf3.visible && this.tbDocProf3.text != "" )) )
    {
        const row: any = new ModelRow("imaging/Rendition-DocumentProfiles", true);
        const id = this.tbDocProf2.visible ? this.tbDocProf2.text : this.tbDocProf3.text;
        if( id == "" )
            return;
        const seq = (id == this.tbDocProf3.text) ? 1 : (this.tblDocProf.rowCount + 1);
        const appid = this.tblApps.selectedRow.data._data.imap_appid
        const catid = this.tblDocs.selectedRow.data._data.icat_catid;
        await this.sourceRenditionDocumentProfiles.search( { "docp_id": id } );
        if( id == this.tbDocProf3.text && this.sourceRenditionDocumentProfiles.rowCount > 0 )
        {
            const msg: any = "Document profile '" + id + "' already exists, cannot add duplicate profile.";
            CommonDialogs.showMessage(msg, "Document Power", { resizable: true, movable: true });
            return;
        }
        await this.sourceRenditionDocumentProfiles.search( { "docp_id": id, "docp_appid": appid, "docp_catid": catid } );
        if( this.sourceRenditionDocumentProfiles.rowCount <= 0 )
        {   //does not exist, so add it
            row.set( "docp_id", id );
            row.set( "docp_seq", seq );
            row.set( "docp_appid", appid );
            row.set( "docp_catid", catid );

            row.mode = DataSourceMode.ADD;
            this.sourceRenditionDocumentProfiles.setRowsAndMode( row.mode, [row], null );
            this.sourceRenditionDocumentProfiles.mode = DataSourceMode.ADD;
            const rrow = await this.sourceRenditionDocumentProfiles.post();
            if( rrow == null )
            {
                CommonDialogs.showMessage("Error adding document profile '" + id + "'.",
                    "Document Power", { resizable: true, movable: true });
                return;
            }
            else
            {
                this.tblApps.selectionMode = SelectionMode.NONE;
                if( this.tbDocProf3.visible )
                {   //adding new profile, so reload all profiles
                    this.tbDocProf2.items = null;
                    await this.sourceRenditionDocumentProfiles.search( { "docp_id": ">0" } );
                }
                this.tbDocProf3.text = "";
                this.tbDocProf2.text = id;
                this.tbDocProf3.visible = false;
                this.tbDocProf2.visible = true;
                this.pbDelDocProf.enabled = true;
                this.pbAddDocProf.caption = "Add";
                await this.sourceRenditionDocumentProfiles.search( { "docp_id": id } );
            }
        }
        else
        {
            await this.sourceRenditionDocumentProfiles.search( { "docp_id": id } );
            const msg: any = "Document profile '" + id + "' already has an entry for the selected application and document category.";
            CommonDialogs.showMessage(msg, "Document Power", { resizable: true, movable: true });
        }
    }
  }

/** This is an event handler for the onClick event of pbDelSeq. */
  async pbDelSeqOnClick(event: ClickEvent) {
    if( this.tblDocProf.selectedRow != null )
    {
        const rowDel: any = this.tblDocProf.selectedRow.data;
        const id: any = rowDel._data.docp_id;
        const seq: any = rowDel._data.docp_seq;
        const appid: any = rowDel._data.docp_appid;
        const catid: any = rowDel._data.docp_catid;

        rowDel.mode = DataSourceMode.NONE;
        this.sourceRenditionDocumentProfiles.setRowsAndMode( rowDel.mode, [rowDel], null );
        this.sourceRenditionDocumentProfiles.delete();
        //update sequences after deleted row
        let nstr = ">" + seq;
        await this.sourceRenditionDocumentProfiles.search( { "docp_id": id, "docp_seq": nstr } );
        for( let i=0; i < this.sourceRenditionDocumentProfiles.rowCount; i )
        {
            this.sourceRenditionDocumentProfiles.rowIndex = i;
            const rowUpd: any = this.sourceRenditionDocumentProfiles.activeRow;
            let pseq: any = rowUpd._data.docp_seq;
            pseq -= 1;
            rowUpd.set( "docp_seq", pseq );
            rowUpd.mode = DataSourceMode.UPDATE;
            this.sourceRenditionDocumentProfiles.setRowsAndMode( rowUpd.mode, [rowUpd], null );
            await this.sourceRenditionDocumentProfiles.post();
            nstr = ">" + pseq;
            await this.sourceRenditionDocumentProfiles.search( { "docp_id": id, "docp_seq": nstr } );
        }
        await this.sourceRenditionDocumentProfiles.search( { "docp_id": id } );   //reload profile
        if( this.tblDocProf.rowCount == 0 )
        {
            //delete item from dropdown
            const items: any = this.tbDocProf2.items;
            for( let i=0; i < items.length; i++ )
            {
                const item: any = items[i];
                if( item.displayValue == id )
                {
                    items.splice(i, 1);
                    break;
                }
            }
            this.tbDocProf2.items = items;
            this.tbDocProf2.text = "";
        }
    }
  }

/** This is an event handler for the onClick event of pbUpSeq. */
  async pbUpSeqOnClick(event: ClickEvent) {
    if( this.tblDocProf.selectedRow != null && this.tblDocProf.selectedRow.data._data.docp_seq > 1 )
    {
        const rowDel: any = this.tblDocProf.selectedRow.data;
        const id: any = rowDel._data.docp_id;
        const seq: any = rowDel._data.docp_seq;
        const appid: any = rowDel._data.docp_appid;
        const catid: any = rowDel._data.docp_catid;
        //Update selected row to temp seq
        rowDel.set( "docp_seq", 9999 );
        rowDel.mode = DataSourceMode.UPDATE;
        this.sourceRenditionDocumentProfiles.setRowsAndMode( rowDel.mode, [rowDel], null );
        await this.sourceRenditionDocumentProfiles.post();
        //update prev sequence
        const pseq = seq - 1;
        await this.sourceRenditionDocumentProfiles.search( { "docp_id": id, "docp_seq": pseq } );
        for( let i=0; i < this.sourceRenditionDocumentProfiles.rowCount; i++ )
        {
            this.sourceRenditionDocumentProfiles.rowIndex = i;
            const rowUpd: any = this.sourceRenditionDocumentProfiles.activeRow;
            let pseq: any = rowUpd._data.docp_seq;
            pseq += 1;
            rowUpd.set( "docp_seq", pseq );
            rowUpd.mode = DataSourceMode.UPDATE;
            this.sourceRenditionDocumentProfiles.setRowsAndMode( rowUpd.mode, [rowUpd], null );
            await this.sourceRenditionDocumentProfiles.post();
            //reupdate temp row
            rowDel.set( "docp_seq", seq - 1 );
            rowDel.mode = DataSourceMode.UPDATE;
            this.sourceRenditionDocumentProfiles.setRowsAndMode( rowDel.mode, [rowDel], null );
            await this.sourceRenditionDocumentProfiles.post();
            break;
        }
        await this.sourceRenditionDocumentProfiles.search( { "docp_id": id } );   //reload profile
        //this.tblDocProf.selectedIndex = seq - 2;  //select moved row
    }
  }

/** This is an event handler for the onClick event of pbDownSeq. */
  async pbDownSeqOnClick(event: ClickEvent) {
    if( this.tblDocProf.selectedRow != null && this.tblDocProf.selectedRow.data._data.docp_seq < this.tblDocProf.rowCount )
    {
        const rowDel: any = this.tblDocProf.selectedRow.data;
        const id: any = rowDel._data.docp_id;
        const seq: any = rowDel._data.docp_seq;
        const appid: any = rowDel._data.docp_appid;
        const catid: any = rowDel._data.docp_catid;
        //Update selected row to temp seq
        rowDel.set( "docp_seq", 9999 );
        rowDel.mode = DataSourceMode.UPDATE;
        this.sourceRenditionDocumentProfiles.setRowsAndMode( rowDel.mode, [rowDel], null );
        await this.sourceRenditionDocumentProfiles.post();
        //update next sequence
        const pseq = seq + 1;
        await this.sourceRenditionDocumentProfiles.search( { "docp_id": id, "docp_seq": pseq } );
        for( let i=0; i < this.sourceRenditionDocumentProfiles.rowCount; i++ )
        {
            this.sourceRenditionDocumentProfiles.rowIndex = i;
            const rowUpd: any = this.sourceRenditionDocumentProfiles.activeRow;
            let pseq: any = rowUpd._data.docp_seq;
            pseq -= 1;
            rowUpd.set( "docp_seq", pseq );
            rowUpd.mode = DataSourceMode.UPDATE;
            this.sourceRenditionDocumentProfiles.setRowsAndMode( rowUpd.mode, [rowUpd], null );
            await this.sourceRenditionDocumentProfiles.post();
            //reupdate temp row
            rowDel.set( "docp_seq", seq + 1 );
            rowDel.mode = DataSourceMode.UPDATE;
            this.sourceRenditionDocumentProfiles.setRowsAndMode( rowDel.mode, [rowDel], null );
            await this.sourceRenditionDocumentProfiles.post();
            break;
        }
        await this.sourceRenditionDocumentProfiles.search( { "docp_id": id } );   //reload profile
        //this.tblDocProf.selectedIndex = seq;  //select moved row
    }
  }

/** This is an event handler for the onRowDisplay event of table3. */
  table3OnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxFtppSqlgrpid") as Textbox;
    const row1: any = event.getTableRow().data;
    const sqlgrpid: any = row1._data.ftpp_sqlgrpid;
    const rows: any[] = this.sourceDpsqlh.data;
    for( const row of rows )
    {
        if( row._data.sqlh_grpid == sqlgrpid )
        {
            const desc: string = row._data.sqlh_desc.toString();
            const gdesc = sqlgrpid + " - " + desc;
            if( txtbox )
                txtbox.setProps({ text: gdesc/*, color: "warning"*/ });
            return;
        }
    }
  }

/** This is an event handler for the onRowDisplay event of tblLogixProfiles. */
  async tblLogixProfilesOnRowDisplay(event: TableRowDisplayEvent) {
    const midbox = event.getTableRow().findComponentById("textboxLgxpMid") as Textbox;
    const prebox = event.getTableRow().findComponentById("textboxLgxpPrefid") as Textbox;
    const row: any = event.getTableRow().data;
    const mid: any = row._data.lgxp_masterpid;
    const prefid: any = row._data.lgxp_prefuncid;
    const profileid: any = row._data.lgxp_id;
    let rows: any[] = this.sourceRenlgxpflds2.data;
    for( const row of rows )
    {
        if( row._data.lgxpf_profileid == profileid )
        {   //prevent deletion of profile with associated fields
            event.getTableRow().allowDelete = false;
            event.getTableRow().setProps({ tooltip: "Profile has associated fields and cannot be deleted." });
            break;
        }
    }
    if( event.getTableRow().allowDelete == true )
    {
        rows = this.sourceRenditionProperties.data;
        for( const row of rows )
        {
            if( row._data.renp_xid == profileid )
            {   //prevent deletion of profile with associated rendition properties
                event.getTableRow().allowDelete = false;
                event.getTableRow().setProps({ tooltip: "Profile is used in rendition properties and cannot be deleted." });
                break;
            }
        }
    }
    rows = this.sourceDxmasterp.data;
    for( const row of rows )
    {
        if( row._data.dxm_id == mid )
        {   //one master id for wdp-renlgx
            const name: string = row._data.dxm_name.toString();
            const desc = mid + " - " + name;
            if( midbox )
                midbox.setProps({ text: desc/*, color: "warning"*/ });
            break;
        }
    }
    const desc = prefid + " - " + funcsMap.get(prefid);
    prebox.setProps({ text: desc/*, color: "warning"*/ });
  }

/** This is an event handler for the afterExecution event of sourceRenditionLogixProfiles. */
  async sourceRenditionLogixProfilesAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    for (const row of rows) {
            //one master id for wdp-renlgx
            const mid = row._data.lgxp_masterpid;
            if( funcsMap.size == 0 )
                await this.loadFuncsMap( mid );
            break;
        }
    }

  async loadFuncsMap( mid: any ) {
    await this.sourceDxproject.search( { dxp_master_id: mid, dxp_status: "A" } );
    if( this.sourceDxproject.data.length == 0 )
        await this.sourceDxproject.search( { dxp_master_id: mid } );
    if( this.sourceDxproject.data.length == 0 )
        return;
    const rows: any[] = this.sourceDxproject.data;
    const pid = rows[0]._data.dxp_proj_id;
    if( pid && pid >= 0 )
    {
        await this.sourceDxfunction.search( { dxf_proj_id: pid } );
        const rows: any[] = this.sourceDxfunction.data;
        funcsMap.clear();
        for (const row of rows) {
            const fid: string = row._data.dxf_func_id;
            const fname: string = row._data.dxf_name;
            funcsMap.set( fid, fname );
        }
    }
  }
}
